import { currentBrand } from '@pb/utils'

export const teliumTrackingScript = (): void => {
  const scriptId = 'tealiumScript'
  const monkiScriptId = 'utagMainScript'
  const isTealiumScriptEnabled =
    document.body.contains(document.getElementById(scriptId)) ||
    document.body.contains(document.getElementById(monkiScriptId))
  if (!isTealiumScriptEnabled) {
    const cdnPath = process.env.CDN_PATH
    const cdnPathDev = cdnPath?.includes('development')

    const getTealiumURL = (): string => {
      let url = '//tags.tiqcdn.com/utag/'
      let brandName = currentBrand
      if (brandName === 'arket') {
        brandName = 'p11'
      }

      if (brandName === 'otherStories') {
        brandName = 'stories'
      }

      const env = cdnPathDev ? 'dev' : 'prod'
      url += `hm/brands-${brandName}/${env}/utag.js`

      return url
    }

    const script = document.createElement('script')
    script.src = getTealiumURL()
    script.id = scriptId
    script.type = 'text/javascript'
    script.async = true

    document.body.appendChild(script)
  }
}
